import { createAction } from '@reduxjs/toolkit';

export const HANDLE_UA_UNAUTHORIZED = 'saga/handleUAUnAuthorized';
export const handleUAUnAuthorizedAction = createAction(HANDLE_UA_UNAUTHORIZED);
